// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
require('whatwg-fetch');
module.exports = self.fetch.bind(self);



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/isomorphic-fetch/fetch-npm-browserify.js
// module id = 682
// module chunks = 168707334958949